export enum CompanyType {
  Regular = 'רגיל',
  Occasional = 'מזדמן'
}
